<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
              Drop And Go (สาขา {{ branchSelected }})
          </h1>
        </div>
      </div>
    </section>
    <section class="section" v-if="!openAdd && !openEdit">
      <button  class="button is-danger" v-on:click="openAdd=true" >เพิ่มงาน Drop & Go</button><br><br>
      <div class="text-left"><input type="checkbox" v-model="pending_only" checked> <b>แสดงเฉพาะรายการค้าง</b></div><br>
      <div class="container">
          <span v-show="!dataAlready">Loading....</span>
          <table class="table is-striped" style="width:100%" v-show="dataAlready">
              <thead>
                  <tr>
                    <th><abbr title="name">ชื่อลูกค้า</abbr></th>
                    <th><abbr title="tel">เบอร์โทร</abbr></th>
                    <th><abbr title="licenseNo">เลขทะเบียน</abbr></th>
                    <th><abbr title="frameNo">เลขเฟรม</abbr></th>
                    <th><abbr title="appointmentDate">วัน-เวลาที่นัด</abbr></th>
                    <th><abbr title="detail">รายละเอียดซ่อม</abbr></th>
                    <th><abbr title="zr12">ZR-12</abbr></th>
                    <th><abbr title="action"></abbr></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="car in carList">
                  <tr v-bind:key="car.id" v-if="(pending_only && car.status=='notcomplete') || !pending_only">
                    <td>{{car.name}}</td>
                    <td>{{car.tel}}</td>
                    <td>{{car.licenseNo}}</td>
                    <td>{{car.frameNo}}</td>
                    <td>{{car.appointmentDate.split('T')[0]}}<br>{{car.appointmentTime}}</td>
                    <td>{{car.detail}}</td>
                    <td width="50">
                      {{car.zr12No}}<br>
                      <a :href="car.zr12file" target="_blank" v-if="car.zr12file">ซ่อมทั่วไป</a><br>
                      <a :href="car.zr12file2" target="_blank" v-if="car.zr12file2">ซ่อมเพิ่มเติม</a>
                    </td>
                    <td>
                      <button  class="button is-small is-link" v-if="car.status=='notcomplete'" v-on:click="uploadDoc($event, car.id)" >Upload ZR-12</button>
                      <button  class="button is-small is-danger" v-if="car.status=='notcomplete'" v-on:click="closeJob(car.id)" >Delete</button>
                    </td>
                  </tr>
                </template>
              </tbody>
          </table>
      </div>
    </section>

    <section class="section section_form" v-if="openAdd">
      <div class="container"><br>
        <p v-if="errors.length">
          <ul>
            <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
          </ul><br>
        </p>

        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.name }"><span class="has-text-danger">*</span> ชื่อลูกค้า</label>
          <div class="control">
            <input class="input" type="text" placeholder="ชื่อลูกค้า" v-model="form.name">
          </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.tel }"><span class="has-text-danger">*</span> เบอร์โทรลูกค้า</label>
          <div class="control">
            <input class="input" type="text" placeholder="เบอร์โทรลูกค้า" v-model="form.tel">
          </div>
        </div>

        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.licenseNo }"><span class="has-text-danger">*</span> เลขทะเบียนรถ</label>
          <div class="control">
            <input class="input" type="text" placeholder="เลขทะเบียนรถ" v-model="form.licenseNo">
          </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.frameNo }"><span class="has-text-danger">*</span> เลขเฟรม</label>
          <div class="control">
            <input class="input" type="text" placeholder="เลขเฟรม" v-model="form.frameNo">
          </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.branchCode }"><span class="has-text-danger">*</span> สาขาที่เข้ารับบริการ</label>
            <div class="select">
                <select v-model="form.branchCode">
                  <option v-for="row in branch" v-bind:key="row.id + Math.random()" :value="row.id">{{row.name}}</option>
                </select>
            </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.appointmentDate }"><span class="has-text-danger">*</span> วันที่ต้องการเข้ารับบริการ</label>
          <div class="control">
            <datepicker v-model="form.appointmentDate" :language="languages[language]" input-class="inputDate"></datepicker>
          </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.appointmentTime }"><span class="has-text-danger">*</span> เวลาที่ต้องการเข้ารับบริการ</label>
          <div class="select">
              <select v-model="form.appointmentTime">
                <option v-for="row in appointmentTime" v-bind:key="row + Math.random()" :value="row">{{row}}</option>
              </select>
          </div>
        </div>
        <div class="field">
          <label class="label" v-bind:class="{ 'has-text-danger': errors.detail }"><span class="has-text-danger">*</span> รายละเอียดการเข้าบริการ</label>
          <div class="control">
            <textarea class="textarea" placeholder="ข้อมูลเพิ่มเติม หรือ บริการพิเศษ" v-model="form.detail"></textarea>
          </div>
        </div>
        <br>
        <button class="button is-link" v-show="!saving" v-on:click="addJob">บันทึก</button>&nbsp;&nbsp;&nbsp;
        <button class="button is-danger" v-show="!saving" v-on:click="cancelUpdate">ยกเลิก</button>
        <span v-show="saving">กำลังบันทึกข้อมูล...</span>
        <br><br>
      </div>
    </section>

    <section class="section" v-if="openEdit">
      <div class="container">
          <h2 class="title is-4">Upload เอกสาร ZR-12 ของหมายเลขทะเบียน {{ editData.licenseNo }}</h2>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">หมายเลข ZR-12</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input class="input" type="text" v-model="editData.zr12No">
                </p>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">เอกสาร ZR-12 (ซ่อมทั่วไป)</label>
            </div>
            <div class="field-body fieldfile">
              <a :href="editData.zr12file" target="_blank">{{editData.zr12file}}</a>
              <fileupload caption="อัพโหลดไฟล์" inputId="file" @downloadURL="editData.zr12file = $event"></fileupload><br>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">เอกสาร ZR-12 (ซ่อมเพิ่มเติม)</label>
            </div>
            <div class="field-body fieldfile">
              <a :href="editData.zr12file2" target="_blank">{{editData.zr12file2}}</a>
              <fileupload caption="อัพโหลดไฟล์" inputId="file2" @downloadURL="editData.zr12file2 = $event"></fileupload><br>
            </div>
          </div>
          <div class=" are-medium" style="text-align:center">
              <button class="button is-danger" v-show="!saving" v-on:click="cancelUpdate" >ยกเลิก</button>&nbsp;&nbsp;&nbsp;
              <button class="button is-info" v-show="!saving" v-on:click="updateJob" >{{btn_confirm_title}}</button>
              <span v-show="saving">กำลังบันทึกข้อมูล...</span>
          </div>
      </div>
    </section>
  </div>
</template>
<style>
.fieldfile {
  text-align: left;
}
.inputDate {
  width: 100% !important;
  height: 2.25em;
  padding-top: calc(.375em - 1px);
  padding-right: calc(.625em - 1px);
  padding-bottom: calc(.375em - 1px);
  padding-left: calc(.625em - 1px);
  color: #363636;
  font-size: inherit;
  background-color: #fff;
  border: 1px solid transparent;
  border-color: #dbdbdb;
  border-radius: 4px;
}
</style>
<style scoped>
.text-left {
  text-align:left;
  margin-left: 60px;
}
.banner {
  text-align:center;background-color:#000;
}
.hero-body {
    padding: 1.5rem 1.5rem !important
}
.section {
    padding: 1rem 0.2rem !important;
}
.txt_small {
  font-size: 10px;
}
.section_form {
  width: 400px;
  margin: 0 auto;
}
</style>
<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import * as lang from 'vuejs-datepicker/src/locale'
import fileupload from '../FileUploader'

export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
    Datepicker,
    'fileupload': fileupload
  },
  data: () => ({
    pending_only: true,
    dataAlready: false,
    inputdate: '',
    format: 'd MMMM yyyy',
    language: 'th',
    languages: lang,
    saving: false,
    branch: [],
    branchSelected: '',
    branchCode: '',
    carId: '',
    carList: [],
    t: null,
    frommethod: '',
    currentTime: 0,
    editId: '',
    editData: {
      zr12No: '',
      zr12file: '',
      zr12file2: ''
    },
    openEdit: false,
    openAdd: false,
    btn_confirm_title: 'บันทึก',
    appointmentTime: [
      '8:00 น.',
      '9:00 น.',
      '10:00 น.',
      '11:00 น.',
      '12:00 น.',
      '13:00 น.',
      '14:00 น.',
      '15:00 น.',
      '16:00 น.',
      '17:00 น.',
      '18:00 น.',
      '19:00 น.'
    ],
    errors: {
      name: false,
      licenseNo: false,
      tel: false,
      branchCode: false,
      detail: false,
      appointmentDate: false,
      appointmentTime: false
    },
    form: {
      name: '',
      licenseNo: '',
      frameNo: '',
      tel: '',
      branchCode: '',
      detail: '',
      appointmentDate: '',
      appointmentTime: '',
      user: '',
      file: '',
      file2: ''
    }
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.currentTime = Date.now()
    _this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    _this.branchCode = params.get('branchCode')
    _this.form.branchCode = params.get('branchCode')
    if (params.get('editId')) {
      _this.editId = params.get('editId')
      _this.editData.licenseNo = params.get('licenseNo')
      _this.openEdit = true
    }
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.getCarList()
  },
  methods: {
    uploadDoc (event, carId) {
      this.saving = false
      this.openEdit = true
      this.editId = carId
      this.editData = {
        zr12No: '',
        zr12file: '',
        zr12file2: ''
      }
      // this.editData = this.carList.filter((car) => { return carId === car.id })
      // if (this.editData.length > 0) {
      //   this.editData = this.editData[0]
      // }
    },
    cancelUpdate () {
      this.openAdd = false
      this.openEdit = false
      this.clearData()
    },
    clearData () {
      this.editId = ''
      this.editData = null
      this.form = {
        'name': '',
        'licenseNo': '',
        'frameNo': '',
        'tel': '',
        'branchCode': '',
        'detail': '',
        'appointmentDate': '',
        'appointmentTime': '',
        'user': '',
        'file': '',
        'file2': ''
      }
    },
    async getUserId (frameNo) {
      let _this = this
      _this.dataAlready = false
      await this.$axios
        .get(`${this.$apiUrl}getCarByFrameNo?frameNo=${frameNo}`)
        .then(response => {
          _this.dataAlready = true
          _this.form.user = response.data[0]
        })
    },
    checkForm (e) {
      let _this = this
      let result = true

      for (let field in _this.errors) {
        this.errors[field] = false
        if (!_this.form[field]) {
          result = false
          this.errors[field] = true
        }
      }
      e.preventDefault()
      return result
    },
    async closeJob (carId) {
      if (confirm('คุณต้องการลบงานนี้')) {
        this.$axios
          .post(`${this.$apiUrl}dropandgoDel`, {id: carId})
          .then(response => {
            this.clearData()
            this.getCarList()
          })
      }
    },
    async addJob (e) {
      let _this = this
      if (!_this.checkForm(e)) {
        alert('กรุณากรอกข้อมูลให้ครบถ้วน')
        return false
      }
      _this.saving = true
      _this.btn_confirm_title = 'กำลังดำเนินการ'
      let params = this.form
      await this.getUserId(this.form.frameNo)
      this.$axios
        .post(`${this.$apiUrl}dropandgoAdd`, params)
        .then(response => {
          console.log(response)
          _this.btn_confirm_title = 'บันทึก'
          _this.updateSuccess = true
          _this.openEdit = false
          _this.openAdd = false
          _this.editId = ''
          _this.editData = null
          _this.clearData()
          _this.getCarList()
        })
    },
    updateJob () {
      let _this = this
      _this.saving = true
      _this.btn_confirm_title = 'กำลังดำเนินการ'
      let params = {
        zr12No: _this.editData.zr12No,
        zr12file: _this.editData.zr12file,
        zr12file2: _this.editData.zr12file2,
        id: _this.editId
      }
      this.$axios
        .post(`${this.$apiUrl}dropandgoUpdate`, params)
        .then(response => {
          console.log(response)
          _this.btn_confirm_title = 'บันทึก'
          _this.updateSuccess = true
          _this.openEdit = false
          _this.openAdd = false
          _this.editId = ''
          _this.editData = null
          _this.saving = false
          _this.clearData()
          _this.getCarList()
        })
    },
    getCarList () {
      let _this = this
      _this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}dropandgoList?branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DropAndGo/manage.vue